import { useTranslation } from 'react-i18next';
/**
 * Provides translations for the `widget-ui` namespace using react-i18next.
 *
 * This hook ensures that components can access localized strings.
 *
 * @returns {UseTranslationResponse<'widget-ui', undefined>} -
 * A translation response tuple including the translation function `t`,
 * the i18n instance, and the ready flag.
 */
export function useWidgetUiTranslation() {
    return useTranslation('widget-ui');
}
